import React from 'react';
import './style.scss'
import { Form, Select } from 'antd';
import { CommonService } from 'services/CommonService';

const DropdownAntd = ({ list, placeholder, customClass, name, isRequired, onChange, showSearch, defaultValue }) => {
  return (
    <Form.Item className={`dropdown-antd ${customClass || ''}`}>
      <Form.Item name={name} noStyle rules={isRequired ? [
        { required: true, message: 'Trường bắt buộc không được để trống' }
      ] : []}>
        <Select
        placeholder={placeholder}
        className="custom-input"
        onChange={onChange}
        optionFilterProp="children"
        showSearch={showSearch}
        defaultValue={defaultValue}
        filterOption={(input, option) =>
          CommonService.changeAlias2(option?.children).indexOf(CommonService.changeAlias2(input)) >=0
        }
        filterSort={(optionA, optionB) =>
          optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
        }
        >
          {list.map((item, index) => (
            <Select.Option value={item.value} key={index}>{item.text}</Select.Option>
          ))}
        </Select>
      </Form.Item>
    </Form.Item>
  );
}

DropdownAntd.defaultProps = {
  isRequired: true,
  handleChange: () => { },
  list: [],
};

export default React.memo(DropdownAntd);